module.exports = "<ul class=\"form-error\" *ngIf=\"showErrors()\">\r\n    <li *ngFor=\"let error of errors()\">{{ error }}</li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/formError/formError.component.html
// module id = ./src/app/components/common/formError/formError.component.html
// module chunks = main